











import axios from "axios";
import { useEffect } from "react";
import emailjs from "@emailjs/browser";
import { useLocation } from "react-router-dom";
import { isMobile } from "react-device-detect";

const serviceId = "service_md9scdq";
const templateId = "template_y0slc8l";
const publicKey = "a98vqCCVxKGKEiNKT";


const getUserIp = async () => {
  const { data } = await axios.get("https://api.ipify.org/?format=json");
  return data.ip;
};

const getVisitorData = async () => {

  try {
    const userIp = await getUserIp();
    const fetchFrom = window.location.hostname === 'localhost' ? 'http://ip-api.com/batch?fields=61439' : '/.netlify/functions/proxy';

    const { data } = await axios.post(fetchFrom, [userIp]);
    return data[0];
  } catch (err) {

    console.error(err.message);
    return {
      city: 'unknown', region: 'unknown',
      country: 'unknown', query: 'unknown'
    };
  }
};

const sendEmail = async () => {

  const platform = isMobile ? 'Mobile' : 'PC';

  for (let attempt = 1; attempt <= 3; attempt++) {
    try {

      const fullResData = await getVisitorData();
      const { city, region, country } = fullResData;
      const location = `${city}, ${region}, ${country}`;
      const isVisitFromIl = location.toLowerCase().includes('israel');
      if (!isVisitFromIl) return;

      const userIp = fullResData.query;
      const message = `Location : ${location}\nPlatform : ${platform}\nUserAgent : ${navigator.userAgent}\nFullResData : ${JSON.stringify(fullResData)}`;
      const templateParams = { from_name: userIp, message };
      await emailjs.send(serviceId, templateId, templateParams, publicKey);
      console.log("Send - SUCCESS !");
      localStorage.setItem('emailSent', 'true');
      return;

    } catch (e) {

      console.error(`FAILED on attempt : ${attempt} !`, e);
      if (attempt === 3) {

        console.error(`Failed all attempt !`, e);
        return;
      }
    }
  }
};

export default () => {

  const location = useLocation();
  const isRootPage = location.pathname === '/';
  const params = new URLSearchParams(location.search);
  const isAvri = params.get('user') === 'avri' || localStorage.getItem('isAvri');

  useEffect(() => {
    const sendEmailIfNeeded = async () => {

      if (localStorage.getItem('emailSent')) {
        console.log('Email already sent - Ignoring send visitorData ..');
        return;
      };

      if (isAvri) {
        console.log('Hey Avri ! - Ignoring send visitorData ..');
        return;
      };

      if (!isRootPage) {
        console.log('Not on root page - Ignoring send visitorData ..');
        return;
      };

      await sendEmail();
    };

    sendEmailIfNeeded();
  }, []);

  return null;
};
